export const normalizeServiceId = (value: unknown): string | null => {
  if (typeof value === 'string' && value.trim()) {
    return value.trim();
  }
  if (value && typeof value === 'object') {
    const candidate =
      (value as { _id?: unknown; id?: unknown })._id || (value as { _id?: unknown; id?: unknown }).id;
    return typeof candidate === 'string' && candidate.trim() ? candidate.trim() : null;
  }
  return null;
};
